//Componentes generales
import React, { useState } from "react";
import moment from "moment";
import { Buffer } from "buffer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import { createPDFOp } from "../../api/pagosYRetenciones";

const RenderRow = ({ pago }) => {
  /* 
        Función encargada de abrir en base 64 un String. Utilizada para ver el informe de Orden de Pago o Retención en pdf.
    */
  function openBase64PDF(base64String) {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    const fileUrl = URL.createObjectURL(blob);
    window.open(fileUrl);
  }

  const generarPDF = async (pago) => {
    try {
      const resp = await createPDFOp(pago.codFor, pago.nroFor); //clienteAxios.post('/pago/informe', { codFor: pago.codFor, nroFor: pago.nroFor });

      const buff = Buffer.from(resp.data, "base64");
      const base64 = buff.toString("base64");

      openBase64PDF(base64);
    } catch (error) {
      console.log(error);
      console.log("Error en generar informe Orden de pago o Retención PDF");
    }
  };

  const handleClickV2 = async () => {
    GlobalWorkerOptions.workerSrc =
      "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js";
    let rgLink =
      "https://drive.google.com/file/d/1r89u_E3bYnaEx-pWv6V6XAl8a3110-2d/view?usp=sharing";
    let opLink =
      "https://drive.google.com/file/d/1pKMSHmpQ_kdaRyKMFyrePYTuPPTtGXij/view?usp=sharing";
    fetch(pago.tDocCodFor == "OP" ? opLink : rgLink)
      .then((res) => res.arrayBuffer())
      .then((pdfData) => {
        console.log("pdfData");
        console.log(pdfData);

        getDocument({ data: pdfData }).promise.then((pdf) => {
          pdf.getPage(1).then((page) => {
            const viewport = page.getViewport({ scale: 1 });
            console.log("Llego hasta aca");
          });
        });
      });
  };

  return (
    <div className="pagoOretenDiv">
      <div className="pago-list-item-header-fch">
        {moment(pago.fchMov).format("DD-MM-YYYY")}
      </div>
      <div className="pago-list-item-header-clave">
        {pago.codFor + " - " + pago.nroFor}
      </div>
      <div className="pago-list-item-header-title">
        {pago.comprobanteDescrp}
      </div>
      <div className="margin-right-r">
        <button onClick={() => generarPDF(pago)}>
          <FontAwesomeIcon icon={faPrint} />
        </button>
      </div>
    </div>
  );
};

export default RenderRow;